module.exports = __webpack_public_path__ + "media/images/truck-dcff042a4f734ecab52d9ecbd542489a.png";